import { useTranslation } from '@/helpers/translate';

function Ambiences({ ambiences }) {
  const { t } = useTranslation();
  return (
    <section className="flex flex-wrap gap-2 md:flex-row text-dark">
      {!ambiences || ambiences.map((a) => (
        <div className="px-2 py-1 text-sm rounded bg-purple/10 text-purple" key={`ambience${a}`}>
          {t(`space:type.${a}`)}
        </div>
      ))}
    </section>
  );
}

export default Ambiences;
